import {
  CalendarEventFormFields,
  TimeFormatOptions,
  Timestamp,
} from '@griply/types';
import { isSameDay } from 'date-fns';

import { formatTimeOfDay } from './format-time-of-day';
import { getDateLabel } from './get-date-label';

export type CalendarEventWhenLabelsInput = Pick<
  CalendarEventFormFields,
  'allDay' | 'startDate' | 'startTime' | 'endDate' | 'endTime'
>;

export type CalendarEventWhenLabels = {
  dateLabel: string;
  // null for an all-day event: this util has no `t`, so the caller supplies its own copy
  timeLabel: string | null;
};

// Absolute day labels for the detail summary; deliberate parallel to getExternalEventTimeLabel, which reads raw boundaries for grid rows.
export const getCalendarEventWhenLabels = (
  {
    allDay,
    startDate,
    startTime,
    endDate,
    endTime,
  }: CalendarEventWhenLabelsInput,
  today: Timestamp,
  timeFormat?: TimeFormatOptions,
): CalendarEventWhenLabels => {
  const start = getDateLabel(startDate, today);
  const dateLabel = isSameDay(startDate, endDate)
    ? start
    : `${start} – ${getDateLabel(endDate, today)}`;

  if (allDay) {
    return { dateLabel, timeLabel: null };
  }

  return {
    dateLabel,
    timeLabel: `${formatTimeOfDay(startTime, timeFormat)}–${formatTimeOfDay(
      endTime,
      timeFormat,
    )}`,
  };
};
